module.exports = __webpack_public_path__ + "img/12.e43e292b.png";